import React from "react";
import { useNavigate } from "react-router-dom";

import { Typography } from "@otp/ui";
import { Arrow } from "@otp/icons";

export interface PageTitleProps {
  title: string;
}

export const PageTitle = ({ title }: PageTitleProps) => {
  const navigate = useNavigate();
    const goBack = () => {
      if (window.history.state?.idx > 0) {
        navigate(-1);
      }
    };

  return (
    <div className="flex items-center pt-3">
      <Arrow className="mr-3 cursor-pointer" onClick={goBack} />
      <Typography variant="h6" fontWeight="bold">
        {title}
      </Typography>
    </div>
  );
};
